import { styled } from '@mui/material';
import { sidebarSectionClickableStyles } from './common-sidebar-section';

export const StyledSidebarButton = styled('button')(({ theme }) =>
  sidebarSectionClickableStyles(theme)
);
